<style lang="scss" scoped>
.el-select-input {
    position: relative;
    display: flex;
    &.no-br-right {
        input {
            border-radius: 4px 0 0 4px;
        }
    }
    &.no-br-left {
        input {
            border-radius: 0 4px 4px 0;
        }
    }
    &.active {
        .select-input-arrow {
            transform: rotate(180deg);
        }
    }
    &:not(.small) {
        input {
            padding: 1rem;
            height: 56px;
        }
        label ~ .form-control.select-input ~ .el-select-input-dropdown,
        .label-error ~ .form-control.select-input ~ .el-select-input-dropdown {
            top: 97px;
        }
    }
    &.small {
        input {
            padding: 0.5rem 1rem;
            height: 40px;
        }
    }

    .input-wrapper {
        margin-top: 10px;
    }

    .select-input {
        caret-color: transparent;
        cursor: pointer;
        user-select: none;
        transition: border-color 0.3s;
        color: var(--dark);

        &.error {
            border-color: var(--danger);
        }
        &::selection {
            background: transparent;
        }
        &::-moz-selection {
            background: transparent;
        }
        &:focus {
            outline: none;
            box-shadow: none !important;
            border-color: var(--primary-dark);
        }
        &::placeholder {
            color: rgba(51, 51, 51, 0.5) !important;
        }
        &:-ms-input-placeholder {
            color: rgba(51, 51, 51, 0.5) !important;
        }
        &::-ms-input-placeholder {
            color: rgba(51, 51, 51, 0.5) !important;
        }
        & ~ .select-input-arrow {
            pointer-events: none;
            cursor: pointer;
            position: absolute;
            right: 27px;
            top: 50%;
            margin-top: -1.5px;
        }
    }

    .el-select-input-dropdown {
        background: #fff;
        position: absolute;
        top: 68px;
        min-width: 100%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background-color: #ffffff;
        border: none;
        z-index: 10;
        font-size: 1rem;
        max-height: 196px;
        overflow: auto;
        .item {
            padding: 12px 24px;
            user-select: none;
            cursor: pointer;
            transition: 0.3s background;
            white-space: nowrap;
            &:hover,
            &.selected {
                background-color: rgba(40, 48, 72, 0.05);
            }
            &:last-child {
                border-radius: 0 0 2px 2px;
            }
        }
        &.top {
            border-radius: 2px 2px 0 0;
            top: auto !important;
            bottom: 55px;
        }
    }
}
label,
.label-error {
    margin-bottom: 0;
    background: #fff;
    left: 11px;
    top: 0px;
    padding: 0;
    color: var(--dark);
    font-weight: 400;
    line-height: 22px;
    display: flex;
}
.label-error {
    color: var(--danger);
    font-weight: 700;
}
.form-control:disabled,
.form-control[readonly] {
    background-color: #fff;
    opacity: 1;
}
</style>

<template>
    <div class="form-group el-input el-select-input flex-column" ref="selectInput" :class="{ active : showOptions }" v-click-outside="() => { showOptions = false  }">
        <label v-if="(!errors.has(name, scope) && !forcedError) && hasLabel" :for="_uid + 'Id'" class="small">
            {{ label }}
            <slot name="label-cta">

            </slot>
        </label>
        <span v-else-if="hasLabel || forcedError" class="label-error small">{{ forcedError || errors.first(name, scope) }}</span>
        <div class="position-relative input-wrapper" :class="{'mt-0' : !hasLabel}">
            <input class="form-control select-input" :disabled="disabled" :class="[{error : forcedError || errors.has(name)}, `tc_${name}_select`]" :value="(!translate) ?  localValue : $t(localValue)" @focus="showOptions = true" v-on:keyup.enter="$emit('enter')" @keydown.tab="() => { showOptions = false}" v-on:keyup.prevent.up="handleKeyUp" v-on:keyup.prevent.down="handleKeyDown" :ref="refName" v-validate="rule" :data-vv-scope="scope" :name="name" type="text" :id="name" :placeholder="placeholder" readonly="readonly">
            <i-arrow-down class="ml-5 select-input-arrow"></i-arrow-down>
        </div>
        <div v-if="showOptions" class="el-select-input-dropdown" :class="direction">
            <div class="item" :class="{selected : localValue === option }" v-for="(option, key) in filteredOptions" :key="key" @click="update(option), showOptions = false" v-html="typeof (option) === 'object' ? (!translate) ? option[labelKey] : $t(option[labelKey]) : (!translate) ?  option : $t(option[labelKey])"></div>
        </div>
    </div>
</template>

<script>

export default {
    inject: ["$validator"],
    props: {
        /**
         * String defining the value
         * @type {String, Object}
         */
        value: {
            type: [String, Object],
            default: ""
        },

        /**
         * String defining the input name
         * @type {String}
         */
        name: {
            type: String,
            default: ""
        },

        /**
         * String defining the input label
         * @type {String}
         */
        label: {
            type: String,
            default: ""
        },

        /**
         * String defining the input placeholder
         * @type {String}
         */
        placeholder: {
            type: String,
            default: ""
        },

        /**
         * validation defining the rules to be applied
         * @type {String}
         */
        rule: {
            type: String,
            default: ""
        },

        /**
         * scope in which the validation rules are applied
         * @type {String}
         */
        scope: {
            type: String,
            default: null
        },

        refName: {
            type: String,
            default: ""
        },

        /**
         * Boolean that defines if we have label
         * @type {Boolean}
         */
        hasLabel: {
            type: Boolean,
            default: true
        },

        /**
         * Boolean that defines the input is disabled
         * @type {Boolean}
         */
        disabled: {
            type: Boolean,
            default: false
        },

        /**
         * String that defines the dropdown direction
         * @type {String}
         */
        direction: {
            type: String,
            default: "bottom"
        },

        /**
         * Boolean that defines if we have label
         * @type {Boolean}
         */
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },

        valueKey: {
            default: 'value'
        },
        labelKey: {
            default: 'label'
        },
        translate: {
            default: false
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        forcedError: {
            type: String,
            default: null,
        }
    },
    mounted() {
        let self = this;
        let el = this.$refs.selectInput.querySelector('.select-input')
        if (el) el.tcOpen = function () { self.showOptions = true }
    },

    data() {
        return {
            localValue: typeof (this.value) === 'object' ? this.value[this.labelKey] : this.value,
            showOptions: false,
            search: ""
        };
    },
    methods: {
        update(option) {
            this.localValue = (typeof (option) === 'object') ? option[this.labelKey] : option
            this.$emit("input", option);
        },
        hideOptions() {
            this.showOptions = false;
        },
        handleKeyUp() {
            let index = this.options.indexOf(this.localValue);

            if (index === 0)
                this.localValue = this.options[this.options.length - 1];
            else this.localValue = this.options[index - 1];
        },
        handleKeyDown() {
            let index = this.options.indexOf(this.localValue);

            if (index === this.options.length - 1)
                this.localValue = this.options[0];
            else this.localValue = this.options[index + 1];
        }
    },
    computed: {
        filteredOptions() {
            return this.options.filter(post => {
                let p = typeof (post) === 'object' ? post[this.labelKey] : post
                return p.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    watch: {
        value: function () {
            this.localValue = typeof (this.value) === 'object' ? this.value[this.labelKey] : this.value;
        }
    },
    directives: {
        'click-outside': {
            bind: function (el, binding, vNode) {
                // Provided expression must evaluate to a function.
                if (typeof binding.value !== 'function') {
                    const compName = vNode.context.name
                    let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                    if (compName) { warn += `Found in component '${compName}'` }

                    console.warn(warn)
                }
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler

                // add Event Listeners
                if (document.getElementById('app'))
                    document.getElementById('app').addEventListener('click', handler, true)
            },

            unbind: function (el) {
                // Remove Event Listeners
                if (document.getElementById('app'))
                    document.getElementById('app').removeEventListener('click', el.__vueClickOutside__)

                el.__vueClickOutside__ = null

            }
        },
    },
};
</script>
